import { useCallback } from 'react'
import { useResizeDetector } from 'react-resize-detector'

import { Box, Divider, Stack } from "@mui/material"

import { ColumnSplitter } from 'components/controls/splitter'
import { Loading } from 'components/controls/loading'
import { ErrorBlock } from 'components/controls/errorInfo'
import { SearchWordField } from 'components/controls/searchWordField'
import { WordCloud } from 'components/graph/wordCloud'

import { SisetuResult } from 'interface/sisetu'
import { ArticleList } from './components/articleList'
import { AuthorsTable } from './components/authorsTable'
import { ArticleBarGraph } from './components/articleBarGraph'

import { useSisetusArticlePage } from './container'
import { useSisetuPreview } from 'features/sisetu/preview/container'

type SisetuPreviewJournalPageProps = {
  sisetu: SisetuResult
  container: ReturnType<typeof useSisetuPreview>
}
export const SisetuPreviewJournalPage = ({
  sisetu,
  container: {
    onArticleOpen,
    selectedArticleId
  }
}: SisetuPreviewJournalPageProps) => {
  const { width, ref } = useResizeDetector()

  const container = useSisetusArticlePage({ sisetuCode: sisetu.sisetuCode })
  const {
    searchWord, setSearchWord,
		selectedYear, setSelectedYear,
		selectedAuthorId, setSelectedAuthorId,
		selectedMesh, setSelectedMesh,
    //selectedPublicationType, setSelectedPublicationType,
		loading, error,
		articles, authors, yearsStats, meshStats, /*publicationTypeStats*/
  } = container

  const onSelectedArticle = useCallback(
    (articleId: number) => {
      const article = articles.find(article => article.articleId === articleId)
      if (!article) return
      onArticleOpen(article, articles)
    },
    [onArticleOpen, articles]
  )
  return (
    <>
      {loading ? <Loading/> :
       error ? <ErrorBlock error={error} padding={1}/> : (
        <ColumnSplitter initialSizes={[66, 34]}>
          <Stack
            ref={ref}
            direction='column'
            height='100%'
            position='relative'
            overflow='hidden'
          >
            <Stack
              direction="column"
              flexShrink={0}
              spacing={1}
              padding={1}
            >
              {(width !== undefined && width > 0) && (
                <WordCloud
                  position='relative'
                  flexShrink={0}
                  overflow='hidden'
                  width={width}
                  height={150}
                  words={meshStats.list.slice(0, 100).map(mesh => ({
                    text: mesh.description,
                    value: mesh.count
                  }))}
                  selected={selectedMesh}
                  setSelected={setSelectedMesh}
                />
              )}

              <Stack
                flexShrink={0}
                overflow="hidden"
                direction="row"
                justifyContent="center"
              >
                <Box width="100%" maxWidth="60rem">
                  <ArticleBarGraph
                    yearsStats={yearsStats}
                    selectedYear={selectedYear}
                    setSelectedYear={setSelectedYear}
                    height={80}
                  />
                </Box>
              </Stack>
            </Stack>

            <Divider/>

            <AuthorsTable
              flexGrow={1}
              overflow='hidden'
              authors={authors}
              selectedAuthorId={selectedAuthorId}
              setSelectedAuthorId={setSelectedAuthorId}
            />
          </Stack>

          <Stack
            direction='column'
            height='100%'
            overflow='hidden'
          >
            <Box
              flexShrink={0}
              padding={1}
            >
              <SearchWordField
                id='search-word-article'
                searchWord={searchWord}
                onChangeSearchWord={setSearchWord}
                fullWidth
              />
            </Box>
            <Divider/>
            <Box
              flexGrow={1}
              overflow='auto'
              position='relative'
            >
              <ArticleList
                articles={articles}
                selectedArticleId={selectedArticleId}
                onSelChangeArticle={onSelectedArticle}
              />
            </Box>
          </Stack>
        </ColumnSplitter>
      )}
    </>
  )
}